import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

/**
 * Copyright (c) Nicolas Gallagher.
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @noflow
 */
import React from 'react';
import createElement from 'react-native-web/dist/cjs/exports/createElement';

var PickerItem = /*#__PURE__*/function (_React$Component) {
  _inherits(PickerItem, _React$Component);

  var _super = _createSuper(PickerItem);

  function PickerItem() {
    _classCallCheck(this, PickerItem);

    return _super.apply(this, arguments);
  }

  _createClass(PickerItem, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          color = _this$props.color,
          label = _this$props.label,
          testID = _this$props.testID,
          value = _this$props.value;
      var style = {
        color: color
      };
      return createElement('option', {
        style: style,
        testID: testID,
        value: value
      }, label);
    }
  }]);

  return PickerItem;
}(React.Component);

export { PickerItem as default };